import React from "react";
import SidebarLogo from "../SidebarLogo/SidebarLogo";
import clsx from "clsx";
import DesktopNavigation from "../Navigations/DesktopNavigation";
import CurrentUserCardInfo from "../CurrentUserCardInfo/CurrentUserCardInfo";
import useCollapsibles from "../../hooks/useCollapsibles";
import { motion } from "framer-motion";

const Sidebar: React.FC = () => {
  const { collapsiblePreferences } = useCollapsibles();

  return (
    <motion.div
      initial={false}
      animate={{
        width: collapsiblePreferences.navIsCollapsed ? "110px" : "240px", // ajusta el valor colapsado si necesitas
      }}
      transition={{
        ease: "easeInOut",
        type: "spring",
        stiffness: 400,
        damping: 17,
        duration: 0.3,
      }}
      className={clsx([
        "hidden",
        "md:flex",
        "flex-col",
        "md:h-full",
        "md:justify-between",
        "bg-blue-900 dark:bg-gray-900",
        "dark:text-white text-white",
        "text-md",
        "font-light",
        "gap-14",
        "py-2 md:py-4",
        "md:pb-0",
        "px-4",
        "justify-start",
        "z-10",
        "shadow-md shadow-gray-100/80",
        {
          "items-center": collapsiblePreferences.navIsCollapsed,
          "md:px-5": !collapsiblePreferences.navIsCollapsed,
        },
        "z-50 fixed top-0 md:relative",
        "rounded-full md:rounded-none mt-4 md:mt-0",
        "left-4 right-4 md:left-auto md:right-auto",
        "md:!shadow-[rgba(0,0,0,0.4)_2px_0_10px]",
      ])}
    >
      <div
        className={clsx([
          "flex",
          "flex-row",
          "md:flex-col",
          "gap-4",
          "md:gap-6",
          "w-full",
          "justify-between",
          "md:justify-normal",
          "md:overflow-hidden",
          "md:h-full",
        ])}
      >
        <div
          className={clsx([
            "hidden",
            "md:flex",
            "justify-center",
            "text-white",
          ])}
        >
          <SidebarLogo rotate={collapsiblePreferences.navIsCollapsed} />
        </div>
        <div
          className={clsx([
            "flex",
            "max-h-full",
            "flex-col",
            "flex-grow",
            "md:overflow-hidden",
            "h-full",
            "no-scrollbar",
          ])}
        >
          <div
            className={clsx([
              "hidden",
              "md:flex",
              "flex-col",
              "h-full",
              "gap-8",
            ])}
          >
            <div
              className={clsx([
                "flex",
                "w-full",
                "items-center",
                "justify-center",
                "dark:text-white",
                "text-black",
              ])}
            >
              <CurrentUserCardInfo />
            </div>

            <div
              className={clsx([
                "flex",
                "flex-grow",
                "overflow-auto",
                "no-scrollbar",
                "w-full",
                "items-start",
                "justify-center",
              ])}
            >
              <DesktopNavigation />
            </div>
          </div>
        </div>
        {/* <InstallPwa kind="save" classNames="w-full" /> */}
      </div>
    </motion.div>
  );
};

export default React.memo(Sidebar);
